import { basename as d } from "path";
import m, { toRaw as p, defineComponent as v, onMounted as f, onUnmounted as w } from "vue";
import { t as a, n as b, a as g } from "./chunks/_plugin-vue2_normalizer-VrK6B12S.mjs";
import { h as j, f as G, g as Z, d as q, e as z, c as W, T as J, b as K, l as Q, k as X, s as Y, i as tt, m as et, j as st } from "./chunks/_plugin-vue2_normalizer-VrK6B12S.mjs";
import _ from "@nextcloud/vue/dist/Components/NcDialog.js";
import y from "@nextcloud/vue/dist/Components/NcNoteCard.js";
/**
 * @copyright Copyright (c) 2023 Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const u = (e, t, s = () => {
}) => {
  const i = document.createElement("div");
  (document.querySelector(t?.container) || document.body).appendChild(i);
  const n = new m({
    el: i,
    name: "VueDialogHelper",
    render: (r) => r(e, {
      props: t,
      on: {
        close: (...l) => {
          s(...l.map((h) => p(h))), n.$destroy();
        }
      }
    })
  });
  return n;
}, A = '<svg xmlns="http://www.w3.org/2000/svg" id="mdi-folder-move" viewBox="0 0 24 24"><path d="M14,18V15H10V11H14V8L19,13M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6Z" /></svg>', T = '<svg xmlns="http://www.w3.org/2000/svg" id="mdi-folder-multiple" viewBox="0 0 24 24"><path d="M22,4H14L12,2H6A2,2 0 0,0 4,4V16A2,2 0 0,0 6,18H22A2,2 0 0,0 24,16V6A2,2 0 0,0 22,4M2,6H0V11H0V20A2,2 0 0,0 2,22H20V20H2V6Z" /></svg>';
/**
 * @copyright Copyright (c) 2023 Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
var C = /* @__PURE__ */ ((e) => (e[e.Choose = 1] = "Choose", e[e.Move = 2] = "Move", e[e.Copy = 3] = "Copy", e[e.CopyMove = 4] = "CopyMove", e[e.Custom = 5] = "Custom", e))(C || {});
class M extends Error {
}
class N {
  title;
  multiSelect;
  mimeTypeFilter;
  directoriesAllowed;
  buttons;
  path;
  filter;
  container;
  disabledNavigation;
  constructor(t, s, i, o, n, r, l, h, c = !1) {
    this.title = t, this.multiSelect = s, this.mimeTypeFilter = i, this.directoriesAllowed = o, this.path = r, this.filter = l, this.buttons = n, this.container = h, this.disabledNavigation = c;
  }
  /**
   * Pick files using the FilePicker
   *
   * @return Promise with array of picked files or rejected promise on close without picking
   */
  async pick() {
    const { FilePickerVue: t } = await import("./chunks/index-CqRCpcyw.mjs");
    return new Promise((s, i) => {
      u(t, {
        allowPickDirectory: this.directoriesAllowed,
        buttons: this.buttons,
        container: this.container,
        name: this.title,
        path: this.path,
        mimetypeFilter: this.mimeTypeFilter,
        multiselect: this.multiSelect,
        filterFn: this.filter,
        disabledNavigation: this.disabledNavigation
      }, (...o) => {
        const [n] = o;
        !Array.isArray(n) || n.length === 0 ? i(new M("FilePicker: No nodes selected")) : this.multiSelect ? s(n.map((r) => r.path)) : s(n[0]?.path || "/");
      });
    });
  }
}
class S {
  title;
  multiSelect = !1;
  mimeTypeFilter = [];
  directoriesAllowed = !1;
  path;
  filter;
  buttons = [];
  container;
  disabledNavigation = !1;
  /**
   * Construct a new FilePicker
   *
   * @param title Title of the FilePicker
   */
  constructor(t) {
    this.title = t;
  }
  /**
   * Set the container where the FilePicker will be mounted
   * By default 'body' is used
   *
   * @param container The dialog container
   */
  setContainer(t) {
    return this.container = t, this;
  }
  /**
   * Enable or disable picking multiple files
   *
   * @param ms True to enable picking multiple files, false otherwise
   */
  setMultiSelect(t) {
    return this.multiSelect = t, this;
  }
  /**
   * Add allowed MIME type
   *
   * @param filter MIME type to allow
   */
  addMimeTypeFilter(t) {
    return this.mimeTypeFilter.push(t), this;
  }
  /**
   * Set allowed MIME types
   *
   * @param filter Array of allowed MIME types
   */
  setMimeTypeFilter(t) {
    return this.mimeTypeFilter = t, this;
  }
  /**
   * Add a button to the FilePicker
   * Note: This overrides any previous `setButtonFactory` call
   *
   * @param button The button
   */
  addButton(t) {
    return typeof this.buttons == "function" && (console.warn("FilePicker buttons were set to factory, now overwritten with button object."), this.buttons = []), this.buttons.push(t), this;
  }
  /**
   * Set the button factory which is used to generate buttons from current view, path and selected nodes
   * Note: This overrides any previous `addButton` call
   *
   * @param factory The button factory
   */
  setButtonFactory(t) {
    return this.buttons = t, this;
  }
  /**
   * Set FilePicker type based on legacy file picker types
   * @param type The legacy filepicker type to emulate
   * @deprecated Use `addButton` or `setButtonFactory` instead as with setType you do not know which button was pressed
   */
  setType(t) {
    return this.buttons = (s, i) => {
      const o = [], n = s?.[0]?.attributes?.displayName || s?.[0]?.basename, r = n || d(i);
      if (t === 1) {
        let l = a("Choose");
        s.length === 1 ? l = a("Choose {file}", { file: n }) : this.multiSelect && (l = b("Choose %n file", "Choose %n files", s.length)), o.push({
          callback: () => {
          },
          type: "primary",
          label: l
        });
      }
      return (t === 4 || t === 3) && o.push({
        callback: () => {
        },
        label: r ? a("Copy to {target}", { target: r }) : a("Copy"),
        type: "primary",
        icon: T
      }), (t === 2 || t === 4) && o.push({
        callback: () => {
        },
        label: r ? a("Move to {target}", { target: r }) : a("Move"),
        type: t === 2 ? "primary" : "secondary",
        icon: A
      }), o;
    }, this;
  }
  /**
   * Allow to pick directories besides files
   *
   * @param allow True to allow picking directories
   */
  allowDirectories(t = !0) {
    return this.directoriesAllowed = t, this;
  }
  /**
   * Set starting path of the FilePicker
   *
   * @param path Path to start from picking
   */
  startAt(t) {
    return this.path = t, this;
  }
  /**
   * Add filter function to filter file list of FilePicker
   *
   * @param filter Filter function to apply
   */
  setFilter(t) {
    return this.filter = t, this;
  }
  /**
   * Allow to pick directories besides files
   *
   * @param allow True to allow picking directories
   */
  disableNavigation() {
    return this.disabledNavigation = !0, this;
  }
  /**
   * Construct the configured FilePicker
   */
  build() {
    return new N(
      this.title,
      this.multiSelect,
      this.mimeTypeFilter,
      this.directoriesAllowed,
      this.buttons,
      this.path,
      this.filter,
      this.container,
      this.disabledNavigation
    );
  }
}
function R(e) {
  return new S(e);
}
const x = /* @__PURE__ */ v({
  __name: "GenericDialog",
  props: {
    name: null,
    text: null,
    html: null,
    buttons: null,
    severity: null
  },
  setup(e) {
    const t = e, s = () => `${t.name}: ${t.text}`;
    return f(() => window.addEventListener("unload", s)), w(() => window.removeEventListener("unload", s)), { __sfc: !0, props: t, handleUnload: s, NcDialog: _, NcNoteCard: y };
  }
});
var V = function() {
  var t = this, s = t._self._c, i = t._self._setupProxy;
  return s(i.NcDialog, { attrs: { "dialog-classes": "nc-generic-dialog", buttons: t.buttons, name: t.name, message: t.text }, on: { "update:open": function(o) {
    return t.$emit("close");
  } } }, [t.severity ? s(i.NcNoteCard, { attrs: { type: t.severity } }, [s("p", { domProps: { textContent: t._s(t.text) } })]) : t._e(), t.html ? s("div", { domProps: { innerHTML: t._s(t.html) } }) : t._e()], 1);
}, E = [], F = /* @__PURE__ */ g(
  x,
  V,
  E,
  !1,
  null,
  null,
  null,
  null
);
const H = F.exports;
/**
 * @copyright Copyright (c) 2024 Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class I {
  #e;
  #s;
  #i;
  #t;
  #o;
  /** @deprecated */
  #n;
  constructor(t, s, i = [], o) {
    this.#e = t, this.#s = s, this.#i = i, this.#t = o, this.#o = void 0, this.#n = void 0;
  }
  /**
   * @deprecated DO NOT USE! It will be removed in the near future!
   * @param html HTML content
   */
  setHTML(t) {
    return this.#n = t, this;
  }
  /**
   * Spawn and show the dialog - if already open the previous instance will be destroyed
   * @return Promise that resolves when the dialog is answered successfully and rejects on close
   */
  show() {
    return this.#o && this.#o.$destroy(), new Promise((t) => {
      this.#o = u(
        H,
        {
          buttons: this.#i,
          name: this.#e,
          text: this.#s,
          severity: this.#t,
          html: this.#n
        },
        t
      );
    });
  }
  /**
   * Hide and destroy the current dialog instance
   */
  hide() {
    this.#o?.$destroy();
  }
}
class $ {
  #e;
  #s;
  #i;
  #t;
  constructor() {
    this.#e = void 0, this.#s = "", this.#i = "", this.#t = [];
  }
  /**
   * Set dialog name
   * @param name The name or headline of the dialog
   */
  setName(t) {
    return this.#i = t, this;
  }
  /**
   * Set the dialog text
   * @param text Main text of the dialog
   */
  setText(t) {
    return this.#s = t, this;
  }
  /**
   * Set the severity of the dialog
   * @param severity Severity of the dialog
   */
  setSeverity(t) {
    return this.#e = t, this;
  }
  /**
   * Set buttons from array
   * @param buttons Either an array of dialog buttons
   */
  setButtons(t) {
    return this.#t.length > 0 && console.warn("[@nextcloud/dialogs] Dialog buttons are already set - this overrides previous buttons."), this.#t = t, this;
  }
  /**
   * Add a single button
   * @param button Button to add
   */
  addButton(t) {
    return this.#t.push(t), this;
  }
  build() {
    return new I(this.#i, this.#s, this.#t, this.#e);
  }
}
export {
  I as Dialog,
  $ as DialogBuilder,
  N as FilePicker,
  S as FilePickerBuilder,
  M as FilePickerClosed,
  C as FilePickerType,
  j as TOAST_ARIA_LIVE_ASSERTIVE,
  G as TOAST_ARIA_LIVE_OFF,
  Z as TOAST_ARIA_LIVE_POLITE,
  q as TOAST_DEFAULT_TIMEOUT,
  z as TOAST_PERMANENT_TIMEOUT,
  W as TOAST_UNDO_TIMEOUT,
  J as ToastAriaLive,
  K as ToastType,
  R as getFilePickerBuilder,
  Q as showError,
  X as showInfo,
  Y as showMessage,
  tt as showSuccess,
  et as showUndo,
  st as showWarning,
  u as spawnDialog
};
